import { Ellipsis, Title } from '@inflearn/ds-react';

export function UserName({ name }: { name: string }) {
  return (
    <Ellipsis lineClamp={1}>
      <Title order={2} color="dark.9" weight="default" size="h1" maw={650}>
        {name}
      </Title>
    </Ellipsis>
  );
}
